<template>
    <div class="xi" style="background: #F5F5F5;">
        <hd-com></hd-com>
        <div class="banner">
            <div class="banner-text">
                <p>当前位置：<router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>医院列表</a><i class="el-icon-arrow-right"></i><a>医生详情</a><i class="el-icon-arrow-right"></i><a>问诊详情</a></p>
            </div>
        </div>
        <div class="contentRes">
            <div class="contentList">
                <div class="contentStep1Box">
                    <div>
                        <div class="DocPhoneBox">
                            <div class="DocPhoneBoxContent" style="display: flex;">
                                <div style="font-weight: bold;font-size: 16px;color: #333333;margin-right:35px">
                                    预约信息
                                </div>
                                <div style="font-size: 16px;">
                                    <div class="DocTopFlexC">
                                        预约时间：
                                        <div class="DocTopFlexC" style="font-weight: bold;font-size: 16px;color: #333333;">
                                            <span>{{payDetail.scheduleDateS}}</span><span style="margin: 0 5px;">{{payDetail.weekDayW}}</span> <span>{{payDetail.timePeriod == 1 ? '上午' : '下午'}}</span>
                                            <div class="DocDetailYuTag" v-if="payDetail.scheduleDateDay">
                                                {{payDetail.scheduleDateDay == 0 ? '今天' : payDetail.scheduleDateDay + '天后'}}
                                            </div>
                                        </div>
                                    </div>
                                     <div>
                                        患者信息: <span style="font-weight: bold;font-size: 16px;color: #333333;">{{payDetail.patientName}} <span style="margin:0 5px">|</span> {{payDetail.patientType == 0 ? '初诊' : '复诊'}}</span>
                                    </div>
                                     <div>
                                        所患疾病：<span style="font-weight: bold;font-size: 16px;color: #333333;">{{payDetail.patientDis}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="" v-if="payIsChange" style="margin-top:20px">
                        <div class="radioSpan">支付费用</div>
                        <div class="DocTopFlexS">
                            <span style="font-size: 14px;color: #999999;">交易号: <span>{{payDetail.orderNumber}}</span></span>
                            <span>实付款：<span style="font-size: 24px;font-weight: bold;color:#E30D0D"><span style="font-size: 14px;">￥</span>{{payDetail.totalMoney}}</span></span>
                        </div>
                    </div>
                    <div class="orderPayBox"  v-if="payIsChange">
                        <div class="orderPayBoxT">选择付款方式</div>
                        <div  class="orderPayBoxC DocTopFlexC" >
                            <div class="DocTopFlexC" style="margin-right:40px">
                                <el-radio v-model="wxpayType" :label="0"></el-radio>
                                <span class="radioSpan">余额支付 <span style="font-size: 14px;font-weight:400"> {{ '（账户余额:' + UserDistributor.assetsBalance}}元）</span></span>
                            </div>
                            <div class="DocTopFlexC" style="margin-right:40px">
                                <el-radio v-model="wxpayType" :label="1"></el-radio>
                                <img src="../../assets/img/consultation/wechat.png" style="width:35px;30px;margin-right:5px" alt="" srcset="">
                                <span class="radioSpan">微信支付</span>
                            </div>
                            <div class="DocTopFlexC">
                                <el-radio v-model="wxpayType" :label="2" :disabled="payFalse"></el-radio>
                                <img src="../../assets/img/consultation/alipay.png" style="width:91px;32px" alt="" srcset="">
                            </div>
                        </div>
                    </div>
                    <div  v-if="!payIsChange">
                        <div class="orderPayBoxT" style="margin:20px">
                            <div class="radioSpan">订单提交成功，请尽快付款！</div>
                            <div style="font-size: 14px;color: #999999;">交易号: <span>{{payDetail.orderNumber}}</span></div>
                            <div class="DocTopFlexS">
                                <div style="text-align:right;margin-top:15px;display: flex;justify-content: end;">请于
                                        <el-statistic
                                        class="el-statistic1"
                                            ref="statistic"
                                            format="mm 分 ss 秒"
                                             :value="payDetail.payAddTime ?  payDetail.payAddTime : deadline3"
                                            time-indices
                                            @finish="hilarity"
                                            style="width:110px;color:#00AFB5"
                                        ></el-statistic>
                                分内付款，超时将自动取消</div>
                                <span>实付款：<span style="font-size: 24px;font-weight: bold;color:#E30D0D"><span style="font-size: 14px;">￥</span>{{payDetail.totalMoney}}</span></span>
                            </div>
                        </div>
                        <div v-if="wxpayType == 0" >
                            <div class="payYuBox orderPayBoxC" style="margin-top:20px">
                                <el-radio v-model="wxpayType1" :label="0">账户余额{{UserDistributor.assetsBalance}}元</el-radio>
                            </div>
                            <div @click="goQuPay" style="margin-top:10px;margin-left:20px;color: #00AFB5;cursor: pointer;">选择其他支付方式 <i class="el-icon-arrow-right"></i></div>
                            <div class="orderPayBox1">
                                <div>输入支付密码</div>
                                <div class="DocTopFlexC" style="margin-top:10px">
                                    <el-input class="orderPayBox1Input" placeholder="请输入密码" v-model="seePasNumber" show-password></el-input>
                                    <span style="font-size: 14px;color: #00AFB5;margin-left:10px;cursor: pointer;" @click="getPayPwd">忘记密码？</span>
                                </div>
                                <div style="font-size: 14px;color: #999999;margin-top:10px" >请输入6位数字支付密码</div>
                            </div>
                            <div class="orderPayBox1">
                                <div class="DocTopFlexC ">
                                    <div class="DocDetailCanBox" @click="canGoMyPay">取消支付</div>
                                    <div class="DocDetailYuBox" @click="goMyPay">确定支付</div>
                                </div>
                                
                                <!-- <div style="margin-top:15px"><el-checkbox v-model="cssagree">支付即视为你同意相关协议条例</el-checkbox></div> -->
                            </div>
                        </div>
                        <div v-if="wxpayType == 1" >
                            <div class="orderPayBox1">
                                <div @click="goQuPay" style="margin-top:10px;margin-left:20px;color: #00AFB5;cursor: pointer;">选择其他支付方式 <i class="el-icon-arrow-right"></i></div>
                                <div class="DocTopFlexColumn">
                                    <img  style="width:160px;height:160px;" :src="qRcodeUrl" alt="Base64 Image">
                                    <div class="" style="margin-top:15px;color:#333333">微信扫一扫支付</div>
                                    <div class="DocDetailCanBox" style="margin-top:15px" @click="canGoMyPay">取消支付</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="wxpayType == 2" >
                            <div class="orderPayBox1">
                                <div @click="goQuPay" style="margin-top:10px;margin-left:20px;color: #00AFB5;cursor: pointer;">选择其他支付方式 <i class="el-icon-arrow-right"></i></div>
                                <div class="DocTopFlexColumn">
                                    <img  style="width:160px;height:160px;" :src="qRcodeUrl" alt="Base64 Image">
                                    <div class="" style="margin-top:15px;color:#333333">支付宝扫一扫支付</div>
                                    <div class="DocDetailCanBox" style="margin-top:15px" @click="canGoMyPay">取消支付</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="payIsChange"
                    >
                        <div style="text-align:right;margin-top:15px;display: flex;justify-content: end;">请于
                            <el-statistic
                            class="el-statistic1"
                                ref="statistic"
                                format="mm 分 ss 秒"
                                :value="payDetail.payAddTime ?  payDetail.payAddTime : deadline3"
                                time-indices
                                style="width:110px;color:#00AFB5"
                            ></el-statistic>
                    分内付款，超时将自动取消</div>
                        <div style="text-align:right;margin-top:110px">
                            <div class="DocTopFlexS">
                                <div></div>
                                <div class="DocDetailYuBox" @click="goPay">立即付款</div>
                            </div>
                            <el-checkbox v-model="cssagree" style="margin-right:10px"></el-checkbox> 我已经阅读并同意<router-link target="_blank" to="/company/onLineVip"><span style="color:#E74848">《会员在线服务协议》</span> </router-link>和<router-link target="_blank" to="/company/onLinePay"><span style="color:#E74848">《在线付费服务协议》</span></router-link>
                            <!-- <div style="margin-top:15px"><el-checkbox v-model="cssagree">支付即视为你同意相关协议条例</el-checkbox></div> -->
                        </div>
                    
                    </div>
           
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { consultationMain } from "../../components/consultation/consultation";
import { reservationMain } from "../../components/reservation/reservation";
import hdCom from '../../components/header'
import ftCom from '../../components/footer'
export default {
    data() {
        var consultationMainItem = new consultationMain(this.TokenClient, this.Services.Authorization);
        var consultationDrugItem = new consultationMain(this.TokenClient, this.Services.Drug);
        var reservationMainItemDrug = new reservationMain(this.TokenClient, this.Services.Drug);
        return {
            consultationDomain: consultationMainItem,
            consultationDrugDomain:consultationDrugItem,
            reservationDomainDrug: reservationMainItemDrug,
            payDetail:JSON.parse(this.$route.query.payInfo),
            sexTab:1,
            timeLeftTime:'15:00',
            timer:null,
            timeLeft:1 * 60,
            paytimeEnd:null,
            http:'',
            wxpayType:0,
            payFalse:false,
            cssagree:false,
            UserDistributor:{},
            wxpayType1:0,
            seePasNumber:'',
            deadline3: Date.now() + 1000 * 60 * 15,
            payIsChange:true,
            qRcodeUrl:'',
            EditdialogVisible:false
        }
    },
    components: {
        hdCom,
        ftCom,
    },
    mounted(){
        this.http = this.Services.ossUpload;
        this.GetUserDistributorData()
    },
     beforeDestroy() {
         clearInterval(this.timer);
    },
    methods: {
        hilarity(){
            this.$router.push({
                path: "/consultation/orderIndex"
            });
        },
        goNextPhoneEdit(){
            this.EditdialogVisible = true
        },
        goMyPay(){
            var _this = this
            _this.consultationDomain.GetIsSetPayPassword(
            function (data) {
                _this.consultationDomain.GetIsPayPassword(
                {
                    payPassword: _this.seePasNumber,
                },
                function (data) {
                    console.log(data)
                    let params = {
                        clientType: 2,
                        orderNumber: _this.payDetail.orderNumber,
                        payType: _this.wxpayType
                    }
                    _this.reservationDomainDrug.GetDoctorSubmitPay(params, function (data) {
                        _this.$router.push({
                            path: "/reservation/reservationSuccess",
                            query: {
                                type: '1',
                            },
                        });
                    });
                },
                function (error) {
                    console.log(error)
                    _this.$message({
                    type: "info",
                    message: "支付密码错误",
                    });
                }
                );
            },
            function (error) {
                _this
                .$confirm("未设置支付密码？去设置", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    const href = _this.$router.resolve("../personal/resetPassword");
                    window.open(href.href, "_blank");
                });
            }
            );
        },
        canGoMyPay(){
            clearInterval(this.timer);
            var _this = this
            _this.$router.push({
                path: "/reservation/reservationSuccess",
                query: {
                    type: '2',
                },
            });
        },
        getPayPwd() {
            const href = this.$router.resolve("../personal/resetPassword");
            window.open(href.href, "_blank");
        },
        goQuPay(){
             this.payIsChange = true
              clearInterval(this.timer);
        },
        goPay(){
            if (!this.cssagree) {
                this.$message.error('请勾选相关协议');
                return
            }
            if (this.wxpayType == 0) {
                this.payIsChange = false
            } else {
                this.payIsChange = false
                this.goReallPay()
            }
        },
        goReallPay(){
            var _this = this
            let params = {
                clientType: 2,
                orderNumber: _this.payDetail.orderNumber,
                payType: _this.wxpayType,
            }
            _this.reservationDomainDrug.GetDoctorSubmitPay(params,function (data) {
                _this.qRcodeUrl = "data:image/jpeg;base64," + data.data.qRcodeBase64
                var isSuccess = false;
                _this.timer = window.setInterval(() => {
                setTimeout(function () {
                    _this.reservationDomainDrug.GetVerificationSuccessPay(
                    data.data.orderNum,
                    function (data2) {
                            isSuccess = data2.data.state == 1 ? true : false;
                            if (isSuccess) {
                            clearInterval(_this.timer);
                            // _this.$message({
                            //     type: "success",
                            //     message: "支付成功!",
                            // });
                            _this.qRcodeUrl = "";
                            _this.$router.push({
                                path: "/reservation/reservationSuccess",
                                query: {
                                    type: '1',
                                },
                            });
                        }
                    },
                    function (error) {
                        console.log(error);
                    }
                    );
                }, 0);
                }, 5000);
                },
                function (error) {
                    console.log('', error)
                })
        },
        GetUserDistributorData(){
            var _this = this
            _this.consultationDomain.GetUserDistributor(function (data) {
                _this.UserDistributor = data.data
            },
            function (error) {
                console.log('', error)
            })
        },
        goCanBtn(){
            this.$confirm('确认取消本次问诊吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$router.back();
                }).catch(() => {

            });
        }
    },
}
</script>

<style scoped>
.contentRes {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    min-height: 800px;
    margin-bottom: 20px;
}
.banner-text {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 10px;
}
.contentList {
    margin-top: 20px;
    width: 800px;
}
.DocTopFlexC {
    display: flex;
    align-items: center;
}
.DocTopFlexS {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.contentStep1Box {
    margin-top: 15px;
    padding: 30px;
    padding-bottom: 60px;
    background-color: #FFFFFF;
}
.orderPayBox {
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    margin-top: 20px;
}
.orderPayBoxT {
    background: #F5F5F5;
    padding: 10px 20px;
}
.orderPayBoxC {
    padding: 30px 20px;
}
.orderPayBox1 {
    padding: 20px;
}
.orderPayBox1Input {
    width: 240px;
}
.DocTopFlexC ::v-deep .el-radio {
    margin-right:10px !important
}
.DocTopFlexC ::v-deep .el-radio__label {
   display: none;
}

.radioSpan {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
}
.DocTopFlexColumn {
    display: flex;
    align-items: center;
    flex-direction: column;
}
.DocDetailYuBox {
    width: 120px;
    background: #00AFB5;
    border-radius: 5px;
    text-align: center;
    padding: 8px 0;
    font-size: 14px;
    color: #FFFFFF;
    margin-right: 10px;
    cursor: pointer;
}
.DocDetailCanBox {
    width: 120px;
    background: #EDEDED;
    border-radius: 5px;
    text-align: center;
    padding: 8px 0;
    font-size: 14px;
    color: #333333;
    margin-right: 10px;
    cursor: pointer;
}
.payYuBox {
    border: 3px solid #00AFB5;
    padding: 20px 30px;
    width: 600px;
    margin-left: 20px;
    margin-top: 10px;
}
 ::v-deep .el-statistic1 .con  {
    color: #00AFB5 !important
}
.DocPhoneBox {
    background: #F5F5F5;
    border-radius: 4px;
    padding: 20px;
}
.DocPhoneBoxContent {
    background: #FFFFFF;
    border-radius: 4px;
    padding:20px 30px ;
}
.DocPhoneBoxContentEdit {
    padding: 15px 20px;
    background: #F5F5F5;
    border-radius: 4px;
    margin-top: 6px;
}
 .diseaseBox ::v-deep input{
    background: #F5F5F5 !important;
    /* border-radius: 4px; */
    border: none;
}
.DocDetailYuTag {
    width: 50px;
    text-align: center;
    /* padding: 2px 0; */
    font-size: 12px;
    color: #999999;
    border-radius: 2px;
    border: 1px solid #CCCCCC;
    margin-left: 8px;
}
</style>
